/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import {Country} from '../../../../model/country';
import MessageWithModal from './components/MessageWithModal';
import PhoneNumberLookup from '../../../../components/PhoneNumberLookup';
import PhoneVerificationCodeInput from '../../../../components/PhoneVerificationCodeInput';
import {Button} from 'react-bootstrap';
import PhoneVerificationCodeButtons from '../../../../components/PhoneVerificationCodeButtons';
import {phoneNumberNumeric} from '../../../../model/formatting';

class PhoneNumber extends React.Component<Props> {

	static defaultProps: Props = {
		lookupValue: {
			country: 'NETHERLANDS',
			phoneNumber: ''
		},
		maximumDurationInSeconds: null,
		onPhoneNumberLookupChange: () => {
			// do nothing
		},
		onPhoneNumberLookupSubmit: () => {
			// do nothing
		},
		onVerificationCodeChange: () => {
			// do nothing
		},
		onVerificationCodeSubmit: () => {
			// do nothing
		},
		onVerificationStopRequested: () => {
			// do nothing
		},
		phoneNumberLookupActive: false,
		phoneNumberLookupResolved: false,
		phoneNumberLookupSubmitDisabled: false,
		verificationCode: '',
		verificationCodeActive: false,
		verificationCodeSubmitDisabled: false,
		violations: {}
	};

	handlePhoneNumberLookupChange = (country: Country, phoneNumber: string): void => {
		const props: Readonly<Props> = this.props;

		props.onPhoneNumberLookupChange(country, phoneNumber);
	};

	handlePhoneNumberLookupSubmit = (): void => {
		const props: Readonly<Props> = this.props;

		if (!props.phoneNumberLookupSubmitDisabled && props.phoneNumberLookupResolved)
			props.onPhoneNumberLookupSubmit({
				country: props.lookupValue.country,
				phoneNumber: phoneNumberNumeric(props.lookupValue.phoneNumber)
			});
	};

	handleVerificationCodeSubmit = (): void => {
		const props: Readonly<Props> = this.props;

		if (!props.verificationCodeSubmitDisabled)
			props.onVerificationCodeSubmit(props.verificationCode);
	};

	handleVerificationStopRequested = (): void => {
		const props: Readonly<Props> = this.props;

		if (!props.verificationCodeSubmitDisabled)
			props.onVerificationStopRequested();
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<React.Fragment>
				<MessageWithModal/>
				<PhoneNumberLookup
					lookupValue={props.lookupValue}
					violations={props.violations.phoneNumberLookup}
					disabled={props.phoneNumberLookupSubmitDisabled}
					onChange={this.handlePhoneNumberLookupChange}
					onEnter={this.handlePhoneNumberLookupSubmit}
					autoFocus={true}/>
				<PhoneVerificationCodeInput
					verificationCode={props.verificationCode}
					autoFocus={false}
					maximumDurationInSeconds={props.maximumDurationInSeconds}
					verificationStopped={props.verificationCodeSubmitDisabled}
					violations={props.violations.verificationCode}
					onVerificationCodeChange={props.onVerificationCodeChange}
					onVerificationCodeEnter={this.handleVerificationCodeSubmit}/>
				{
					props.phoneNumberLookupActive &&
					<Button
						type="submit"
						className="float-end"
						variant="primary"
						onClick={this.handlePhoneNumberLookupSubmit}
						disabled={props.phoneNumberLookupSubmitDisabled || !props.phoneNumberLookupResolved}>
						{'Verifieer'}
					</Button>
				}
				{
					props.verificationCodeActive &&
					<PhoneVerificationCodeButtons
						verificationStopped={false}
						submitDisabled={props.verificationCodeSubmitDisabled}
						onSubmitVerificationCode={this.handleVerificationCodeSubmit}
						onIndicateVerificationCodeNotReceived={this.handleVerificationStopRequested}/>
				}
			</React.Fragment>
		);
	}
}

export default PhoneNumber;
